/*
* === TermsOfServicePage.js (Updated - Aligned with System V1.0) ===
*/
import React from 'react';
import { Container, Typography, Paper, Box, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const TermsOfServicePage = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2 }}>
                
                {/* Header */}
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <GavelIcon color="secondary" sx={{ fontSize: 60, mb: 1 }} />
                    <Typography variant="h3" fontWeight="bold" gutterBottom>
                        Terms of Service
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary">
                        Last Updated: December 2025
                    </Typography>
                </Box>

                <Divider sx={{ mb: 4 }} />

                {/* Content */}
                <Box sx={{ '& h6': { fontWeight: 'bold', mt: 3, mb: 1, color: 'secondary.main' } }}>
                    
                    <Typography variant="h6">1. Acceptance of Terms</Typography>
                    <Typography paragraph>
                        By accessing or using the BrightSparc platform ("Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not use the Service.
                    </Typography>

                    <Typography variant="h6">2. Use of the Service</Typography>
                    <Typography paragraph>
                        BrightSparc provides a platform connecting students ("Applicants") with organizations offering bursaries ("Funders"). 
                        We facilitate the application process but do not guarantee funding.
                    </Typography>
                    <Typography paragraph><strong>You agree to:</strong></Typography>
                    <List dense>
                        <ListItem><ListItemIcon><CheckCircleOutlineIcon fontSize="small" color="secondary"/></ListItemIcon><ListItemText primary="Provide accurate, current, and complete information in your Profile and Applications." /></ListItem>
                        <ListItem><ListItemIcon><CheckCircleOutlineIcon fontSize="small" color="secondary"/></ListItemIcon><ListItemText primary="Maintain the security of your password and account credentials." /></ListItem>
                        <ListItem><ListItemIcon><CheckCircleOutlineIcon fontSize="small" color="secondary"/></ListItemIcon><ListItemText primary="Use the Service only for lawful purposes and in accordance with these Terms." /></ListItem>
                    </List>

                    <Typography variant="h6">3. User Responsibilities</Typography>
                    <Typography paragraph>
                        <strong>Applicants:</strong> You are solely responsible for the accuracy of the documents and information you submit. Providing false information may result in the rejection of your application and suspension of your account.
                    </Typography>
                    <Typography paragraph>
                        <strong>Funders:</strong> You are responsible for managing your bursary funds, reviewing applications fairly, and complying with all applicable laws regarding data privacy and non-discrimination.
                    </Typography>

                    <Typography variant="h6">4. Intellectual Property</Typography>
                    <Typography paragraph>
                        The Service and its original content, features, and functionality are and will remain the exclusive property of BrightSparc and its licensors. 
                        You retain ownership of the documents you upload to your Digital Vault.
                    </Typography>

                    <Typography variant="h6">5. Termination</Typography>
                    <Typography paragraph>
                        We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                    </Typography>

                    <Typography variant="h6">6. Limitation of Liability</Typography>
                    <Typography paragraph>
                        In no event shall BrightSparc, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
                    </Typography>

                    <Typography variant="h6">7. Changes to Terms</Typography>
                    <Typography paragraph>
                        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect.
                    </Typography>

                    <Typography variant="h6">8. Contact Us</Typography>
                    <Typography paragraph>
                        If you have any questions about these Terms, please contact us at:
                    </Typography>
                    <Typography fontWeight="bold" color="secondary">
                        legal@brightsparc.co.za
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default TermsOfServicePage;